<template>
  <div ref="screen_wrap">
    <van-sticky :offset-top="stickyTop" :z-index="zIndex">
      <div class="screen_content">
        <screen
          ref="screen"
          :options="options"
          @comfirm="confirm"
          v-bind="$attrs"
          v-on="$listeners"
        >
          <slot></slot>
        </screen>
        <div class="screen_mask">
          <div
            v-for="(v, i) in options"
            :key="i"
            class="mask_item"
            @click.stop="screenOpen(i)"
          ></div>
        </div>
      </div>
    </van-sticky>
  </div>
</template>
<script>
import screen from './index.vue';
import { smoothScroll } from '@utils/';
export default {
  components: {
    screen,
  },
  props: {
    stickyTop: {
      type: Number,
      default: 44,
    },
    zIndex: {
      type: Number,
      default: 999,
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  methods: {
    confirm(...args) {
      // this.scrollToSticky()
      this.$emit('confirm', ...args);
    },
    // 打开筛选框
    screenOpen(index) {
      // 获取screen到顶部的距离
      const top = this.$refs.screen.$el.getClientRects()[0].top;
      if (top > this.stickyTop + 1) {
        this.scrollToSticky();
        setTimeout(() => {
          this.$refs.screen.dropMenuTogggle(index);
        }, 300);
      } else {
        this.$refs.screen.dropMenuTogggle(index);
      }
    },
    // 滚动至吸顶
    scrollToSticky() {
      const top =
        this.$refs.screen_wrap.getClientRects()[0].top +
        window.scrollY -
        // (document.getElementsByClassName('ignore-title')[0]?.offsetHeight || 0);
        this.stickyTop;
      smoothScroll(top + 1);
    },
  },
};
</script>
<style scoped lang="less">
.screen_content {
  position: relative;
}
.screen_mask {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  display: flex;
  .mask_item {
    flex: 1;
  }
}
</style>
